import mixpanel, {Dict} from 'mixpanel-browser';
import {useSelector} from "react-redux";
import {IRootState} from "../redux/states";
// mixpanel.init('YOUR_MIXPANEL_TOKEN');
mixpanel.init('6630b8d47871ecddbf2f18e930a83278');

let env_check = process.env.NODE_ENV === 'production';


// const stateAll = useSelector((state: IRootState) => state);
// const currentUser = stateAll.setting.user!;

let actions = {
  identify: (id:string) => {
    if (env_check)
      mixpanel.identify(id);
  },
  alias: (id:string) => {
    if (env_check)
      mixpanel.alias(id);
  },
  track: (name:string, props:Dict) => {
    if (env_check){
        props = {
            ...props,
            "x-ecampus-version": "2025.05.1",
            "x-ecampus-platform": "web",
            "x-ecampus-id": props?.user_id || '',
            "x-ecampus-lang": "ENG",
        }
        mixpanel.track(name, props);
    }

      // console.log("Mixpanel - track", name, props, );
  },
  people: {
    set: (props:Dict) => {
      if (env_check)
        mixpanel.people.set(props);
    },
  },
};

export let Mixpanel = actions;